
import axios from "axios";
import { adminMainUrl } from "../../Config";
import Cookies from 'js-cookie';
//PRODUCT//
export const ProductType = (slug) => {
    return async function (dispatch) {

        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/product-type/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchProductTypeSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchProductTypeRequest = () => ({
    type: "FIND_PRODUCT_PAGE_REQUEST",
});

export const fetchProductTypeSuccess = (data) => ({
    type: "FIND_PRODUCT_PAGE_SUCCESS",
    payload: data,
});

export const fetchProductTypeFailure = (error) => ({
    type: "FIND_PRODUCT_PAGE_FAILURE",
    payload: error,
});
//PRODUCT//

//Shipment//
export const ShipmentTypeApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/shipment-type/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchShipmentTypeSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchShipmentTypeRequest = () => ({
    type: "FIND_SHIPMENT_PAGE_REQUEST",
});

export const fetchShipmentTypeSuccess = (data) => ({
    type: "FIND_SHIPMENT_PAGE_SUCCESS",
    payload: data,
});

export const fetchShipmentTypeFailure = (error) => ({
    type: "FIND_SHIPMENT_PAGE_FAILURE",
    payload: error,
});
//Shipment//

//ShipmentMode//
export const ShipmentModeTypeApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/shipment-mode/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchShipmentModeTypeSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchShipmentModeTypeRequest = () => ({
    type: "FIND_SHIPMENTMODE_PAGE_REQUEST",
});

export const fetchShipmentModeTypeSuccess = (data) => ({
    type: "FIND_SHIPMENTMODE_PAGE_SUCCESS",
    payload: data,
});

export const fetchShipmentModeTypeFailure = (error) => ({
    type: "FIND_SHIPMENTMODE_PAGE_FAILURE",
    payload: error,
});
//ShipmentMode//

//ShipmentVia//
export const ShipmentViaTypeApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/shipment-via/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchShipmentViaTypeSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchShipmentViaTypeRequest = () => ({
    type: "FIND_SHIPMENTVIA_PAGE_REQUEST",
});

export const fetchShipmentViaTypeSuccess = (data) => ({
    type: "FIND_SHIPMENTVIA_PAGE_SUCCESS",
    payload: data,
});

export const fetchShipmentViaTypeFailure = (error) => ({
    type: "FIND_SHIPMENTVIA_PAGE_FAILURE",
    payload: error,
});
//ShipmentVia//

//CargoType//
export const CargoTypeApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/cargo-type/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchCargoTypeSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchCargoTypeRequest = () => ({
    type: "FIND_CARGO_TYPE_PAGE_REQUEST",
});

export const fetchCargoTypeSuccess = (data) => ({
    type: "FIND_CARGO_TYPE_PAGE_SUCCESS",
    payload: data,
});

export const fetchCargoTypeTypeFailure = (error) => ({
    type: "FIND_CARGO_TYPE_PAGE_FAILURE",
    payload: error,
});
//CargoType//

//DepartmentType//
export const DepartmentTypeApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/department/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchDepartmentTypeSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchDepartmentTypeRequest = () => ({
    type: "FIND_DEPARTMENT_TYPE_PAGE_REQUEST",
});

export const fetchDepartmentTypeSuccess = (data) => ({
    type: "FIND_DEPARTMENT_TYPE_PAGE_SUCCESS",
    payload: data,
});

export const fetchDepartmentTypeTypeFailure = (error) => ({
    type: "FIND_DEPARTMENT_TYPE_PAGE_FAILURE",
    payload: error,
});
//DepartmentType//

//IdProof//
export const IdProofApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': Cookies.get('flexichain_user_id'),
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/id-proof-type/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchIdProofSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchIdProofRequest = () => ({
    type: "FIND_ID_PROOF_TYPE_PAGE_REQUEST",
});

export const fetchIdProofSuccess = (data) => ({
    type: "FIND_ID_PROOF_TYPE_PAGE_SUCCESS",
    payload: data,
});

export const fetchIdProofTypeFailure = (error) => ({
    type: "FIND_ID_PROOF_TYPE_PAGE_FAILURE",
    payload: error,
});
//IdProof//

//Package//
export const PackageApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/package-type/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchPackageSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchPackageRequest = () => ({
    type: "FIND_PACKAGE_TYPE_PAGE_REQUEST",
});

export const fetchPackageSuccess = (data) => ({
    type: "FIND_PACKAGE_TYPE_PAGE_SUCCESS",
    payload: data,
});

export const fetchPackageTypeFailure = (error) => ({
    type: "FIND_PACKAGE_TYPE_PAGE_FAILURE",
    payload: error,
});
//Package//

//Gender//
export const GenderApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/gender/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchGenderSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchGenderRequest = () => ({
    type: "FIND_GENDER_TYPE_PAGE_REQUEST",
});

export const fetchGenderSuccess = (data) => ({
    type: "FIND_GENDER_TYPE_PAGE_SUCCESS",
    payload: data,
});

export const fetchGenderTypeFailure = (error) => ({
    type: "FIND_GENDER_TYPE_PAGE_FAILURE",
    payload: error,
});
//Gender//

//Designation//
export const DesignationApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/designation/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchDesignationSuccess(resData));
                    console.log(resData)
                    console.log("Running designation api")
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchDesignationRequest = () => ({
    type: "FIND_DESIGNATION_TYPE_PAGE_REQUEST",
});

export const fetchDesignationSuccess = (data) => ({
    type: "FIND_DESIGNATION_TYPE_PAGE_SUCCESS",
    payload: data,
});

export const fetchDesignationTypeFailure = (error) => ({
    type: "FIND_DESIGNATION_TYPE_PAGE_FAILURE",
    payload: error,
});
//Designation//

//WeightUnit//
export const WeightUnitApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/weight-unit/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchWeightUnitSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchWeightUnitRequest = () => ({
    type: "FIND_WEIGHT_UNIT_PAGE_REQUEST",
});

export const fetchWeightUnitSuccess = (data) => ({
    type: "FIND_WEIGHT_UNIT_PAGE_SUCCESS",
    payload: data,
});

export const fetchWeightUnitTypeFailure = (error) => ({
    type: "FIND_WEIGHT_UNIT_PAGE_FAILURE",
    payload: error,
});
//WeightUnit//

//RequiredService//
export const RequiredServiceApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/required-service/get`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchRequiredServiceSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchRequiredServiceRequest = () => ({
    type: "FIND_REQUIRED_SERVICE_PAGE_REQUEST",
});

export const fetchRequiredServiceSuccess = (data) => ({
    type: "FIND_REQUIRED_SERVICE_PAGE_SUCCESS",
    payload: data,
});

export const fetchRequiredServiceTypeFailure = (error) => ({
    type: "FIND_REQUIRED_SERVICE_PAGE_FAILURE",
    payload: error,
});
//RequiredService//


//view rates
export const fetchViewRateRequest = () => ({
    type: "FIND_VIEW_RATE_REQUEST",
});

export const fetchViewRateSuccess = (data) => ({
    type: "FIND_VIEW_RATE_SUCCESS",
    payload: data,
});

export const fetchViewRateFailure = (error) => ({
    type: "FIND_VIEW_RATE_FAILURE",
    payload: error,
});

export const getViewRate = (token, user_id, id) => {
    return async function (dispatch) {
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        const requestBody = {
            "quotation_id": `${id}`
        };
        await axios.post(`${adminMainUrl}/api/pricing/list-export-info`, requestBody, config)
            .then((response) => {
                dispatch(fetchViewRateSuccess(response.data?.data));  // Access data from the response
            })
            .catch((error) => {
                console.log("ERROR in getViewRate function (redux):", error);
            });
    }
};

//view rates

//download quotation
export const fetchQuotationRequest = () => ({
    type: "FIND_DOWNLOAD_QUOTATION_REQUEST",
});

export const fetchQuotationSuccess = (data) => ({
    type: "FIND_DOWNLOAD_QUOTATION_SUCCESS",
    payload: data,
});

export const fetchQuotationFailure = (error) => ({
    type: "FIND_DOWNLOAD_QUOTATION_FAILURE",
    payload: error,
});

export const getQuotation = (token, id) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/pricing/download-quote/${id}`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchQuotationSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};



//download quotation
//Profile page//
export const ProfileApi = (slug) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
                Accept: 'application/json',
            }
        };


        await fetch(`${adminMainUrl}/api/get-profile`, config)
            .then((res) => {

                res.json().then((resData) => {
                    dispatch(fetchProfileSuccess(resData));
                })
            }).catch((err) => {
                console.log("ERROR in getAllFeedbackData function(redux):", err);
            })
    }
};
export const fetchProfileRequest = () => ({
    type: "FIND_PROFILE_PAGE_REQUEST",
});

export const fetchProfileSuccess = (data) => ({
    type: "FIND_PROFILE_PAGE_SUCCESS",
    payload: data,
});

export const fetchProfileFailure = (error) => ({
    type: "FIND_PROFILE_PAGE_FAILURE",
    payload: error,
});
//Profile page//


//origin country
export const fetchOriginCountryRequest = () => ({
    type: "FIND_ORIGIN_COUNTRY_REQUEST",
});

export const fetchOriginCountrySuccess = (data) => ({
    type: "FIND_ORIGIN_COUNTRY_SUCCESS",
    payload: data,
});

export const fetchOriginCountryFailure = (error) => ({
    type: "FIND_ORIGIN_COUNTRY_FAILURE",
    payload: error,
});

export const getOriginCountry = () => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/country/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchOriginCountrySuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getCountry function(redux):", err);
            });
    };
};

// origin country

//origin state master
export const fetchOriginStateRequest = () => ({
    type: "FIND_ORIGIN_STATE_REQUEST",
});

export const fetchOriginStateSuccess = (data) => ({
    type: "FIND_ORIGIN_STATE_SUCCESS",
    payload: data,
});

export const fetchOriginStateFailure = (error) => ({
    type: "FIND_ORIGIN_STATE_FAILURE",
    payload: error,
});

export const getOriginState = (id) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/state/list?country_id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchOriginStateSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getState function(redux):", err);
            });
    };
};

//origin state master


//origin city master

export const fetchOriginCityRequest = () => ({
    type: "FIND_ORIGIN_CITY_REQUEST",
});

export const fetchOriginCitySuccess = (data) => ({
    type: "FIND_ORIGIN_CITY_SUCCESS",
    payload: data,
});

export const fetchOriginCityFailure = (error) => ({
    type: "FIND_ORIGIN_CITY_FAILURE",
    payload: error,
});

export const getOriginCity = (id) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/city/list?state_id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchOriginCitySuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getCity function(redux):", err);
            });
    };
};
//origin city master

//origin country
export const fetchDestinationCountryRequest = () => ({
    type: "FIND_DESTINATION_COUNTRY_REQUEST",
});

export const fetchDestinationCountrySuccess = (data) => ({
    type: "FIND_DESTINATION_COUNTRY_SUCCESS",
    payload: data,
});

export const fetchDestinationCountryFailure = (error) => ({
    type: "FIND_DESTINATION_COUNTRY_FAILURE",
    payload: error,
});

export const getDestinationCountry = () => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/country/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchDestinationCountrySuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getCountry function(redux):", err);
            });
    };
};

// origin country

//origin state master
export const fetchDestinationStateRequest = () => ({
    type: "FIND_DESTINATION_STATE_REQUEST",
});

export const fetchDestinationStateSuccess = (data) => ({
    type: "FIND_DESTINATION_STATE_SUCCESS",
    payload: data,
});

export const fetchDestinationStateFailure = (error) => ({
    type: "FIND_DESTINATION_STATE_FAILURE",
    payload: error,
});

export const getDestinationState = (id) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/state/list?country_id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchDestinationStateSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getState function(redux):", err);
            });
    };
};

//origin state master


//origin city master

export const fetchDestinationCityRequest = () => ({
    type: "FIND_DESTINATION_CITY_REQUEST",
});

export const fetchDestinationCitySuccess = (data) => ({
    type: "FIND_DESTINATION_CITY_SUCCESS",
    payload: data,
});

export const fetchDestinationCityFailure = (error) => ({
    type: "FIND_DESTINATION_CITY_FAILURE",
    payload: error,
});

export const getDestinationCity = (id) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/city/list?state_id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchDestinationCitySuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getCity function(redux):", err);
            });
    };
};

//origin city master


//commodity master

export const fetchCommodityRequest = () => ({
    type: "FIND_COMMODITY_REQUEST",
});

export const fetchCommoditySuccess = (data) => ({
    type: "FIND_COMMODITY_SUCCESS",
    payload: data,
});

export const fetchCommodityFailure = (error) => ({
    type: "FIND_COMMODITY_FAILURE",
    payload: error,
});

export const getCommodity = () => {
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/commodity/get`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCommoditySuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getCommodity function(redux):", err);
            });
    };
};

//commodity master

//incoterms
export const fetchIncotermsRequest = () => ({
    type: "FIND_INCOTERMS_REQUEST",
});

export const fetchIncotermsSuccess = (data) => ({
    type: "FIND_INCOTERMS_SUCCESS",
    payload: data,
});

export const fetchIncotermsFailure = (error) => ({
    type: "FIND_INCOTERMS_FAILURE",
    payload: error,
});

export const getIncoterms = (token, user_id) => {
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'auth-token': token,
                'user_id': user_id
            }
        };
        await fetch(`${adminMainUrl}/api/incoterms/get`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchIncotermsSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getIncoterms function(redux):", err);
            });
    };
};

//incoterms

//chargehead
export const fetchChargeheadRequest = () => ({
    type: "FIND_CHARGEHEAD_REQUEST",
});

export const fetchChargeheadSuccess = (data) => ({
    type: "FIND_CHARGEHEAD_SUCCESS",
    payload: data,
});

export const fetchChargeheadFailure = (error) => ({
    type: "FIND_CHARGEHEAD_FAILURE",
    payload: error,
});

export const getChargehead = () => {
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'auth-token': Cookies.get('token'),
                'user_id': Cookies.get('flexichain_user_id')
            }
        };
        await fetch(`${adminMainUrl}/api/chargehead/get`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchChargeheadSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getChargehead function(redux):", err);
            });
    };
};

export const fetchChargeheadByServiceTypeRequest = () => ({
    type: "FIND_CHARGEHEAD_BY_SERVICE_TYPE_REQUEST",
});

export const fetchChargeheadByServiceTypeSuccess = (data) => ({
    type: "FIND_CHARGEHEAD_BY_SERVICE_TYPE_SUCCESS",
    payload: data,
});

export const fetchChargeheadByServiceTypeFailure = (error) => ({
    type: "FIND_CHARGEHEAD_BY_SERVICE_TYPE_FAILURE",
    payload: error,
});

export const getChargeheadByServiceType = (service_type) => {
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'auth-token': Cookies.get('token'),
                'user_id': Cookies.get('flexichain_user_id')
            }
        };
        let body = { service_type: service_type };
        await axios.post(`${adminMainUrl}/api/chargehead/get-chargehead-on-service`, body, config)
            .then((resData) => {
                dispatch(fetchChargeheadByServiceTypeSuccess(resData.data.data));
            }).catch((err) => {
                console.log("ERROR in getChargeheadByServiceType function(redux):", err);
            });
    };
};

//chargehead


//additionals
export const fetchAdditionalsRequest = () => ({
    type: "FIND_ADDITIONALS_REQUEST",
});

export const fetchAdditionalsSuccess = (data) => ({
    type: "FIND_ADDITIONALS_SUCCESS",
    payload: data,
});

export const fetchAdditionalsFailure = (error) => ({
    type: "FIND_ADDITIONALS_FAILURE",
    payload: error,
});



export const getAdditionals = () => {
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/additionals/get`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchAdditionalsSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getAdditionals function(redux):", err);
            });
    };
};

//additionals


//currency master

export const fetchCurrencyRequest = () => ({
    type: "FIND_CURRENCY_REQUEST",
});

export const fetchCurrencySuccess = (data) => ({
    type: "FIND_CURRENCY_SUCCESS",
    payload: data,
});

export const fetchCurrencyFailure = (error) => ({
    type: "FIND_CURRENCY_FAILURE",
    payload: error,
});

export const getCurrency = () => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/currency/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchCurrencySuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getCurrency function(redux):", err);
            });
    };
};
//curerncy master

//expense type master
export const fetchExpenseTypeRequest = () => ({
    type: "FIND_EXPENSE_TYPE_REQUEST",
});

export const fetchExpenseTypeSuccess = (data) => ({
    type: "FIND_EXPENSE_TYPE_SUCCESS",
    payload: data,
});

export const fetchExpenseTypeFailure = (error) => ({
    type: "FIND_EXPENSE_TYPE_FAILURE",
    payload: error,
});

export const getExpenseType = () => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/expense-type/get`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchExpenseTypeSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getExpenseType function(redux):", err);
            });
    };
};

//expense type master


//containertype master

export const fetchContainertypeRequest = () => ({
    type: "FIND_CONTAINERTYPE_REQUEST",
});

export const fetchContainertypeSuccess = (data) => ({
    type: "FIND_CONTAINERTYPE_SUCCESS",
    payload: data,
});

export const fetchContainertypeFailure = (error) => ({
    type: "FIND_CONTAINERTYPE_FAILURE",
    payload: error,
});

export const getContainertype = () => {
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/containertype/get`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchContainertypeSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getContainertype function(redux):", err);
            });
    };
};

//containertype master


//containersize master

export const fetchContainersizeRequest = () => ({
    type: "FIND_CONTAINERSIZE_REQUEST",
});

export const fetchContainersizeSuccess = (data) => ({
    type: "FIND_CONTAINERSIZE_SUCCESS",
    payload: data,
});

export const fetchContainersizeFailure = (error) => ({
    type: "FIND_CONTAINERSIZE_FAILURE",
    payload: error,
});

export const getContainersize = () => {
    return async function (dispatch) {
        let config = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/containersize/get`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchContainersizeSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getContainersize function(redux):", err);
            });
    };
};

//containersize master


//KycDoc list

export const fetchKycDocRequest = () => ({
    type: "FIND_KYC_DOC_REQUEST",
});

export const fetchKycDocSuccess = (data) => ({
    type: "FIND_KYC_DOC_SUCCESS",
    payload: data,
});

export const fetchKycDocFailure = (error) => ({
    type: "FIND_KYC_DOC_FAILURE",
    payload: error,
});

export const getKycDocList = () => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'user_id': Cookies.get('flexichain_user_id'),
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/kyc-doc/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchKycDocSuccess(resData.data));
                })
            }).catch((err) => {
                console.log("ERROR in getKycDoc function(redux):", err);
            });
    };
};

//KycDoc list


//KycDoc view

export const fetchKycDocViewRequest = () => ({
    type: "FIND_KYC_DOC_VIEW_REQUEST",
});

export const fetchKycDocViewSuccess = (data) => ({
    type: "FIND_KYC_DOC_VIEW_SUCCESS",
    payload: data,
});

export const fetchKycDocViewFailure = (error) => ({
    type: "FIND_KYC_DOC_VIEW_FAILURE",
    payload: error,
});

export const getKycDocView = (id) => {
    return async function (dispatch) {
        const token = Cookies.get('token');
        let config = {
            method: "GET",
            headers: {
                'auth-token': token, // Use 'auth-token' header as required by your API
                'Content-Type': 'application/json',
            }
        };
        await fetch(`${adminMainUrl}/api/kyc-doc/view?id=${id}`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchKycDocViewSuccess(resData.data));

                })

            }).catch((err) => {
                console.log("ERROR in getKycDocView function(redux):", err);
            });
    };
};

//KycDoc view


///get countries on UI

export const getMasterCountries = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_COUNTRIES_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/country/list`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_COUNTRIES_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterCountries function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_COUNTRIES_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterCountries function:", error);
            dispatch({
                type: "FIND_MASTER_COUNTRIES_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterCountryDetail = (token, user_id, country_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_COUNTRY_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/country/view`;
        let body = { id: country_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_COUNTRY_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterCountryDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_COUNTRY_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterCountryDetail function:", error);
            dispatch({
                type: "FIND_MASTER_COUNTRY_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

///get states on UI
export const getMasterStates = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_STATES_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/state/list`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_STATES_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterStates function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_STATES_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterStates function:", error);
            dispatch({
                type: "FIND_MASTER_STATES_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterStateDetail = (token, user_id, state_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_STATE_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/state/view`;
        let body = { id: state_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_STATE_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterStateDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_STATE_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterStateDetail function:", error);
            dispatch({
                type: "FIND_MASTER_STATE_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

export const getStateListByCountry = (token, user_id, country_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_STATE_BY_COUNTRY_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/state/list?country_id=${country_id}`;
        // let body = { id: state_id }
        try {
            axios(apiUrl, config).then((res) => {
                // console.log(res.data)
                dispatch({
                    type: "FIND_MASTER_STATE_BY_COUNTRY_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getStateListByCountry function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_STATE_BY_COUNTRY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getStateListByCountry function:", error);
            dispatch({
                type: "FIND_MASTER_STATE_BY_COUNTRY_FAILURE",
                payload: error,
            });
        }
    };
};

export const getGSTStateListByCountry = (token, user_id, country_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_STATE_BY_GST_COUNTRY_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/state/list?country_id=${country_id}`;
        // let body = { id: state_id }
        try {
            axios(apiUrl, config).then((res) => {
                // console.log(res.data)
                dispatch({
                    type: "FIND_MASTER_STATE_BY_GST_COUNTRY_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getGSTStateListByCountry function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_STATE_BY_GST_COUNTRY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getGSTStateListByCountry function:", error);
            dispatch({
                type: "FIND_MASTER_STATE_BY_GST_COUNTRY_FAILURE",
                payload: error,
            });
        }
    };
};

///get cities on UI
export const getMasterCities = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_CITIES_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/city/list`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_CITIES_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterCities function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_CITIES_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterCities function:", error);
            dispatch({
                type: "FIND_MASTER_CITIES_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterCityDetail = (token, user_id, state_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_CITY_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/city/view`;
        let body = { id: state_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_CITY_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterCityDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_CITY_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterCityDetail function:", error);
            dispatch({
                type: "FIND_MASTER_CITY_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};


export const getCityListByState = (token, user_id, state_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_CITY_BY_STATE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/city/list?state_id=${state_id}`;
        // let body = { id: state_id }
        try {
            axios(apiUrl, config).then((res) => {
                // console.log(res.data)
                dispatch({
                    type: "FIND_MASTER_CITY_BY_STATE_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCityListByState function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_CITY_BY_STATE_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCityListByState function:", error);
            dispatch({
                type: "FIND_MASTER_CITY_BY_STATE_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterAirport = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_AIRPORTS_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/airport/list`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_AIRPORTS_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterAirport function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_AIRPORTS_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterAirport function:", error);
            dispatch({
                type: "FIND_MASTER_AIRPORTS_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterAirportDetail = (token, user_id, state_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_AIRPORT_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/airport/view`;
        let body = { id: state_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_AIRPORT_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterAirportDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_AIRPORT_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterAirportDetail function:", error);
            dispatch({
                type: "FIND_MASTER_AIRPORT_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterSeaport = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_SEAPORTS_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/seaport/list`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_SEAPORTS_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterSeaport function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_SEAPORTS_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterSeaport function:", error);
            dispatch({
                type: "FIND_MASTER_SEAPORTS_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterSeaportDetail = (token, user_id, state_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_SEAPORT_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/seaport/view`;
        let body = { id: state_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_SEAPORT_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterSeaportDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_SEAPORT_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterSeaportDetail function:", error);
            dispatch({
                type: "FIND_MASTER_SEAPORT_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterAirline = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_AIRLINES_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/airline/list`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_AIRLINES_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterAirline function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_AIRLINES_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterAirline function:", error);
            dispatch({
                type: "FIND_MASTER_AIRLINES_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterAirlineDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_AIRLINE_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/airline/view`;
        let body = { id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_AIRLINE_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterAirlineDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_AIRLINE_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterAirlineDetail function:", error);
            dispatch({
                type: "FIND_MASTER_AIRLINE_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterShipline = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_SHIPLINES_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/shipline/list`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_SHIPLINES_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterShipline function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_SHIPLINES_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterShipline function:", error);
            dispatch({
                type: "FIND_MASTER_SHIPLINES_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterShiplineDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_SHIPLINE_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/shipline/view`;
        let body = { id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_SHIPLINE_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterShiplineDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_SHIPLINE_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterShiplineDetail function:", error);
            dispatch({
                type: "FIND_MASTER_SHIPLINE_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};


export const getCustomerDetailbyUsername = (username) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CUSTOMER_DETAIL_BY_USERNAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                // 'auth-token': token,
                // 'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/get-customer-detail-by-username`;
        let body = { username: username }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CUSTOMER_DETAIL_BY_USERNAME_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCustomerDetailbyUsername function (redux):", err);
                dispatch({
                    type: "FIND_CUSTOMER_DETAIL_BY_USERNAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCustomerDetailbyUsername function:", error);
            dispatch({
                type: "FIND_CUSTOMER_DETAIL_BY_USERNAME_FAILURE",
                payload: error,
            });
        }
    };
};

//agent IATA

export const getMasterIATAAgent = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/get`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgent function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgent function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentList = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/list`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentList function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentDetail = (token, user_id, iata_agent_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/view`;
        let body = { id: iata_agent_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentList function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentAddressList = (token, user_id, iata_agent_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_ADDRESS_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/address/list`;
        let body = { iata_agent_id: iata_agent_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_ADDRESS_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentAddressList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_ADDRESS_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentAddressList function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_ADDRESS_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentAddressDetail = (token, user_id, address_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_ADDRESS_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/address/view`;
        let body = { id: address_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_ADDRESS_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentAddressDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_ADDRESS_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentAddressDetail function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_ADDRESS_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentSalesList = (token, user_id, iata_agent_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_SALES_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/sales/list`;
        let body = { iata_agent_id: iata_agent_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_SALES_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentSalesList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_SALES_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentSalesList function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_SALES_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentSalesDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_SALES_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/sales/view`;
        let body = { id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_SALES_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentSalesDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_SALES_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentSalesDetail function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_SALES_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentCustomerList = (token, user_id, iata_agent_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_CUSTOMER_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/customer/list`;
        let body = { iata_agent_id: iata_agent_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_CUSTOMER_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentCustomerList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_CUSTOMER_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentCustomerList function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_CUSTOMER_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentCustomerDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_CUSTOMER_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/customer/view`;
        let body = { id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_CUSTOMER_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentCustomerDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_CUSTOMER_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentCustomerDetail function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_CUSTOMER_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentContactList = (token, user_id, iata_agent_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_CONTACT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/contact/list`;
        let body = { iata_agent_id: iata_agent_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_CONTACT_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentContactList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_CONTACT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentContactList function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_CONTACT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterIATAAgentContactDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_IATA_AGENT_CONTACT_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/contact/view`;
        let body = { id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_CONTACT_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterIATAAgentContactDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_IATA_AGENT_CONTACT_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterIATAAgentContactDetail function:", error);
            dispatch({
                type: "FIND_MASTER_IATA_AGENT_CONTACT_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};



export const getMasterAirlineAddressList = (token, user_id, airline_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_AIRLINE_ADDRESS_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/airline/address/list`;
        let body = { airline_id: airline_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_AIRLINE_ADDRESS_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterAirlineAddressList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_AIRLINE_ADDRESS_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterAirlineAddressList function:", error);
            dispatch({
                type: "FIND_MASTER_AIRLINE_ADDRESS_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterAirlineAddressDetail = (token, user_id, address_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_AIRLINE_ADDRESS_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/master/airline/address/view`;
        let body = { id: address_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_AIRLINE_ADDRESS_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterAirlineAddressDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_AIRLINE_ADDRESS_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterAirlineAddressDetail function:", error);
            dispatch({
                type: "FIND_MASTER_AIRLINE_ADDRESS_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//get ff mawb stock Airline list
export const getMasterAirlineList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_AIRLINE_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/airline/get`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_AIRLINE_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterAirlineList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_AIRLINE_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterAirlineList function:", error);
            dispatch({
                type: "FIND_MASTER_AIRLINE_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
export const getAirlineAddressByAirlineList = (token, user_id, airline_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_AIRLINE_ADDRESS_BY_AIRLINE_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/airline/address/get`;
        let body = { airline_id: airline_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_AIRLINE_ADDRESS_BY_AIRLINE_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getAirlineAddressByAirlineList function (redux):", err);
                dispatch({
                    type: "FIND_AIRLINE_ADDRESS_BY_AIRLINE_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getAirlineAddressByAirlineList function:", error);
            dispatch({
                type: "FIND_AIRLINE_ADDRESS_BY_AIRLINE_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getIATAAgentList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_IATA_AGENT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/get`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_IATA_AGENT_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getIATAAgentList function (redux):", err);
                dispatch({
                    type: "FIND_IATA_AGENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getIATAAgentList function:", error);
            dispatch({
                type: "FIND_IATA_AGENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getIATAAgentAddressByIATAAgentList = (token, user_id, iata_agent_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_IATA_AGENT_ADDRESS_BY_IATA_AGENT_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/iata-agent/address/get`;
        let body = { iata_agent_id: iata_agent_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_IATA_AGENT_ADDRESS_BY_IATA_AGENT_LIST_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getIATAAgentAddressByIATAAgentList function (redux):", err);
                dispatch({
                    type: "FIND_IATA_AGENT_ADDRESS_BY_IATA_AGENT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getIATAAgentAddressByIATAAgentList function:", error);
            dispatch({
                type: "FIND_IATA_AGENT_ADDRESS_BY_IATA_AGENT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};


//get rateclass  on UI master
export const getMasterRateclassList = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_RATE_CLASS_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/rateclass/list`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_RATE_CLASS_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterRateclassList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_RATE_CLASS_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterRateclassList function:", error);
            dispatch({
                type: "FIND_MASTER_RATE_CLASS_FAILURE",
                payload: error,
            });
        }
    };
};
export const getMasterRateclassDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_RATE_CLASS_DETAIL_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/rateclass/view`;

        try {
            axios.post(apiUrl, { id: id }, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_RATE_CLASS_DETAIL_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterRateclassDetail function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_RATE_CLASS_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterRateclassDetail function:", error);
            dispatch({
                type: "FIND_MASTER_RATE_CLASS_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

//get  reate class
export const getRateclassList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_RATE_CLASS_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/rateclass/get`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_RATE_CLASS_SUCCESS",
                    payload: res?.data.data,
                });
            }).catch((err) => {
                console.log("ERROR in getRateclassList function (redux):", err);
                dispatch({
                    type: "FIND_RATE_CLASS_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getRateclassList function:", error);
            dispatch({
                type: "FIND_RATE_CLASS_FAILURE",
                payload: error,
            });
        }
    };
};

export const fetchSpecializationListRequest = () => ({
    type: "FIND_SPECIALIZATION_LIST_REQUEST",
});

export const fetchSpecializationListSuccess = (data) => ({
    type: "FIND_SPECIALIZATION_LIST_SUCCESS",
    payload: data,
});

export const fetchSpecializationListFailure = (error) => ({
    type: "FIND_SPECIALIZATION_LIST_FAILURE",
    payload: error,
});

export const getSpecializationList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchSpecializationListRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/master/specialization/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchSpecializationListSuccess(resData));
                })
            }).catch((err) => {
                dispatch(fetchSpecializationListFailure(err.message));
                console.log("ERROR in getSpecializationList function(redux):", err);
            });
    };
};

export const fetchSpecializationActiveListRequest = () => ({
    type: "FIND_SPECIALIZATION_ACTIVE_LIST_REQUEST",
});

export const fetchSpecializationActiveListSuccess = (data) => ({
    type: "FIND_SPECIALIZATION_ACTIVE_LIST_SUCCESS",
    payload: data,
});

export const fetchSpecializationActiveListFailure = (error) => ({
    type: "FIND_SPECIALIZATION_ACTIVE_LIST_FAILURE",
    payload: error,
});

export const getSpecializationActiveList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchSpecializationActiveListRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/master/specialization/active-list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    if (resData) {
                        const data = resData.data
                        dispatch(fetchSpecializationActiveListSuccess(data));
                    }
                })
            }).catch((err) => {
                dispatch(fetchSpecializationActiveListFailure(err.message));
                console.log("ERROR in getSpecializationActiveList function(redux):", err);
            });
    };
};



export const fetchLicenseTypeListRequest = () => ({
    type: "FIND_LICENSE_TYPE_LIST_REQUEST",
});

export const fetchLicenseTypeListSuccess = (data) => ({
    type: "FIND_LICENSE_TYPE_LIST_SUCCESS",
    payload: data,
});

export const fetchLicenseTypeListFailure = (error) => ({
    type: "FIND_LICENSE_TYPE_LIST_FAILURE",
    payload: error,
});

export const getLicenseTypeList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchLicenseTypeListRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/master/licenseType/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchLicenseTypeListSuccess(resData));
                })
            }).catch((err) => {
                dispatch(fetchLicenseTypeListFailure(err.message));
                console.log("ERROR in getLicenseTypeList function(redux):", err);
            });
    };
};


export const fetchLicenseTypeActiveListRequest = () => ({
    type: "FIND_LICENSE_TYPE_ACTIVE_LIST_REQUEST",
});

export const fetchLicenseTypeActiveListSuccess = (data) => ({
    type: "FIND_LICENSE_TYPE_ACTIVE_LIST_SUCCESS",
    payload: data,
});

export const fetchLicenseTypeActiveListFailure = (error) => ({
    type: "FIND_LICENSE_TYPE_ACTIVE_LIST_FAILURE",
    payload: error,
});

export const getLicenseTypeActiveList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchLicenseTypeActiveListRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/master/licenseType/active-list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    if (resData) {
                        const data = resData.data
                        dispatch(fetchLicenseTypeActiveListSuccess(data));
                    }
                })
            }).catch((err) => {
                dispatch(fetchLicenseTypeActiveListFailure(err.message));
                console.log("ERROR in getLicenseTypeActiveList function(redux):", err);
            });
    };
};

export const fetchVehicleTypeListRequest = () => ({
    type: "FIND_VEHICLE_TYPE_LIST_REQUEST",
});

export const fetchVehicleTypeListSuccess = (data) => ({
    type: "FIND_VEHICLE_TYPE_LIST_SUCCESS",
    payload: data,
});

export const fetchVehicleTypeListFailure = (error) => ({
    type: "FIND_VEHICLE_TYPE_LIST_FAILURE",
    payload: error,
});

export const getVehicleTypeList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchVehicleTypeListRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/master/vehicleType/list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    dispatch(fetchVehicleTypeListSuccess(resData));
                })
            }).catch((err) => {
                dispatch(fetchVehicleTypeListFailure(err.message));
                console.log("ERROR in getVehicleTypeList function(redux):", err);
            });
    };
};








export const fetchVehicleTypeActiveListRequest = () => ({
    type: "FIND_VEHICLE_TYPE_ACTIVE_LIST_REQUEST",
});

export const fetchVehicleTypeActiveListSuccess = (data) => ({
    type: "FIND_VEHICLE_TYPE_ACTIVE_LIST_SUCCESS",
    payload: data,
});

export const fetchVehicleTypeActiveListFailure = (error) => ({
    type: "FIND_VEHICLE_TYPE_ACTIVE_LIST_FAILURE",
    payload: error,
});

export const getVehicleTypeActiveList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchVehicleTypeActiveListRequest());
        let config = {
            method: "GET",
            headers: {

                'auth-token': token,
                'user_id': user_id
            },

        };
        await fetch(`${adminMainUrl}/api/transport/master/vehicleType/active-list`, config)
            .then((res) => {
                res.json().then((resData) => {
                    if (resData) {
                        const data = resData.data
                        dispatch(fetchVehicleTypeActiveListSuccess(data));
                    }
                })
            }).catch((err) => {
                dispatch(fetchVehicleTypeActiveListFailure(err.message));
                console.log("ERROR in getVehicleTypeActiveList function(redux):", err);
            });
    };
};


// --------------------------account master-----------------------

export const getMasterAccountParentGroup = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_PARENT_GROUP_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/parent-group`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_PARENT_GROUP_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterCountries function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_PARENT_GROUP_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_PARENT_GROUP_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterAccountGroupType = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_GROUP_TYPE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                "auth-token": token,
                user_id: user_id,
                "Content-Type": "application/json",
            },
        };
        let apiUrl = `${adminMainUrl}/api/account/group-type`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config)
                .then((res) => {
                    dispatch({
                        type: "FIND_MASTER_ACCOUNT_GROUP_TYPE_SUCCESS",
                        payload: res?.data,
                    });
                })
                .catch((err) => {
                    console.log("ERROR in getMasterCountries function (redux):", err);
                    dispatch({
                        type: "FIND_MASTER_ACCOUNT_GROUP_TYPE_FAILURE",
                        payload: err,
                    });
                });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_GROUP_TYPE_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterAccountSubGroupType = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                "auth-token": token,
                user_id: user_id,
                "Content-Type": "application/json",
            },
        };
        let apiUrl = `${adminMainUrl}/api/account/sub-group-type`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config)
                .then((res) => {
                    dispatch({
                        type: "FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_SUCCESS",
                        payload: res?.data,
                    });
                })
                .catch((err) => {
                    console.log("ERROR in getMasterCountries function (redux):", err);
                    dispatch({
                        type: "FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_FAILURE",
                        payload: err,
                    });
                });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_GROUP_TYPE_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterAccountParentGroupIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_PARENT_GROUP_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/parent-group-name`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_PARENT_GROUP_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterparenttype function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_PARENT_GROUP_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_PARENT_GROUP_NAME_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterAccountGroupTypeIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_GROUP_TYPE_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                "auth-token": token,
                user_id: user_id,
                "Content-Type": "application/json",
            },
        };
        let apiUrl = `${adminMainUrl}/api/account/group-type-name`;


        try {
            axios(apiUrl, config)
                .then((res) => {
                    dispatch({
                        type: "FIND_MASTER_ACCOUNT_GROUP_TYPE_NAME_SUCCESS",
                        payload: res?.data,
                    });
                })
                .catch((err) => {
                    console.log("ERROR in getMasterCountries function (redux):", err);
                    dispatch({
                        type: "FIND_MASTER_ACCOUNT_GROUP_TYPE_NAME_FAILURE",
                        payload: err,
                    });
                });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_GROUP_TYPE_NAME_FAILURE",
                payload: error,
            });
        }
    };
};

export const getMasterAccountSubGroupTypeIdAndName = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                "auth-token": token,
                user_id: user_id,
                "Content-Type": "application/json",
            },
        };
        let apiUrl = `${adminMainUrl}/api/account/sub-group-type-name`;

        try {
            axios(apiUrl, config)
                .then((res) => {
                    dispatch({
                        type: "FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_NAME_SUCCESS",
                        payload: res?.data,
                    });
                })
                .catch((err) => {
                    console.log("ERROR in getMasterCountries function (redux):", err);
                    dispatch({
                        type: "FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_NAME_FAILURE",
                        payload: err,
                    });
                });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_SUB_GROUP_TYPE_NAME_FAILURE",
                payload: error,
            });
        }
    };
};

// -----------------Group Master

export const getAllGroupMasterData = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_GROUP_MASTER_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/group-master`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_GROUP_MASTER_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in GROUP MASTER function (redux):", err);
                dispatch({
                    type: "FIND_GROUP_MASTER_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_GROUP_MASTER_FAILURE",
                payload: error,
            });
        }
    };
};

export const getGroupMasterIdAndName = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_GROUP_MASTER_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                "auth-token": token,
                user_id: user_id,
                "Content-Type": "application/json",
            },
        };
        let apiUrl = `${adminMainUrl}/api/account/group-master-name`;

        try {
            axios(apiUrl, config)
                .then((res) => {
                    dispatch({
                        type: "FIND_GROUP_MASTER_NAME_SUCCESS",
                        payload: res?.data,
                    });
                })
                .catch((err) => {
                    console.log("ERROR in group master function (redux):", err);
                    dispatch({
                        type: "FIND_GROUP_MASTER_NAME_FAILURE",
                        payload: err,
                    });
                });
        } catch (error) {
            console.log("Unexpected error in get group master function:", error);
            dispatch({
                type: "FIND_GROUP_MASTER_NAME_FAILURE",
                payload: error,
            });
        }
    };
};



// ---------------ledger account------------------------

export const getAllLedgerAccountIdAndPartyName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_ALL_LEDGER_ACCOUNT_ID_AND_PARTY_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/ledger-account-party-name`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_ALL_LEDGER_ACCOUNT_ID_AND_PARTY_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in ledger-account-party-name function (redux):", err);
                dispatch({
                    type: "FIND_ALL_LEDGER_ACCOUNT_ID_AND_PARTY_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in ledger-account-party-name function:", error);
            dispatch({
                type: "FIND_ALL_LEDGER_ACCOUNT_ID_AND_PARTY_NAME_FAILURE",
                payload: error,
            });
        }
    };
};


export const getMasterAccountLedgerGroupType = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/ledger-group-type`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterCountries function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterAccountLedgerGroupTypeIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/ledger-group-type-name`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterparenttype function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_LEDGER_GROUP_TYPE_NAME_FAILURE",
                payload: error,
            });
        }
    };
};

// -------------tds category------------------------
export const getMasterAccountTdsCategory = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_TDS_CATEGORY_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/tds-category`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_TDS_CATEGORY_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterCountries function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_TDS_CATEGORY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_TDS_CATEGORY_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterAccountTdsCategoryIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_TDS_CATEGORY_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/tds-category-name`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_TDS_CATEGORY_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterparenttype function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_TDS_CATEGORY_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_TDS_CATEGORY_NAME_FAILURE",
                payload: error,
            });
        }
    };
};

// -------------acccout group-------------------------

export const getMasterAccountGroup = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_GROUP_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/account-group`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_GROUP_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in ACCOUNT GROUP function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_GROUP_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in ACCOUNT GROUP function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_GROUP_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterAccountGroupIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_ACCOUNT_GROUP_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/account-group-name`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_GROUP_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in ACCOUNT GROUP function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_ACCOUNT_GROUP_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in ACCOUNT GROUP function:", error);
            dispatch({
                type: "FIND_MASTER_ACCOUNT_GROUP_FAILURE",
                payload: error,
            });
        }
    };
};

// -------------cash book-------------------------

export const getMasterCashBook = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_CASH_BOOK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/cash-book`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_CASH_BOOK_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in CASH BOOK function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_CASH_BOOK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_CASH_BOOK_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterCashBookIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_CASH_BOOK_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/cash-book-name`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_CASH_BOOK_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in CASH BOOK function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_CASH_BOOK_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_CASH_BOOK_NAME_FAILURE",
                payload: error,
            });
        }
    };
};


// -------------branch--master-----------------------

export const getMasterBranch = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_BRANCH_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/branch-master`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_BRANCH_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in BRANCH function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_BRANCH_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_BRANCH_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterBranchIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_BRANCH_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/branch-master-name`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_BRANCH_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in BRANCH function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_BRANCH_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterParent function:", error);
            dispatch({
                type: "FIND_MASTER_BRANCH_NAME_FAILURE",
                payload: error,
            });
        }
    };
};


// -------------tax--master-----------------------

export const getMasterTaxMaster = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_TAXMASTER_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/tax-master`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterTaxMaster function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterTaxMaster function:", error);
            dispatch({
                type: "FIND_MASTER_TAXMASTER_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterTaxMasterIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_TAXMASTER_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/tax-master-name`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getAllMasterTaxMasterIdAndName function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getAllMasterTaxMasterIdAndName function:", error);
            dispatch({
                type: "FIND_MASTER_TAXMASTER_NAME_FAILURE",
                payload: error,
            });
        }
    };
};

export const getTaxMasterCountriesList = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_TAXMASTER_COUNTRIES_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/tax-master/country-list`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_COUNTRIES_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getTaxMasterCountriesList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_COUNTRIES_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getTaxMasterCountriesList function:", error);
            dispatch({
                type: "FIND_MASTER_TAXMASTER_COUNTRIES_FAILURE",
                payload: error,
            });
        }
    };
};

export const getTaxMasterCountryStatesList = (token, user_id, country_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_TAXMASTER_COUNTRY_STATES_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/tax-master/state-by-country-list`;

        let body = {
            country_id: country_id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                console.log(res)
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_COUNTRY_STATES_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getTaxMasterCountryStatesList function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_COUNTRY_STATES_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getTaxMasterCountryStatesList function:", error);
            dispatch({
                type: "FIND_MASTER_TAXMASTER_COUNTRY_STATES_FAILURE",
                payload: error,
            });
        }
    };
};

export const getTaxMasterData = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_TAXMASTER_DATA_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/tax-master/view`;

        let body = {
            id: id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                // console.log(res)
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_DATA_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getTaxMasterData function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_TAXMASTER_DATA_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getTaxMasterData function:", error);
            dispatch({
                type: "FIND_MASTER_TAXMASTER_DATA_FAILURE",
                payload: error,
            });
        }
    };
};
// -------------cost-center--master-----------------------

export const getMasterCostCenter = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_COSTCENTER_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/cost-center-master`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_COSTCENTER_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterCostCenter function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_COSTCENTER_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterCostCenter function:", error);
            dispatch({
                type: "FIND_MASTER_COSTCENTER_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterCostCenterIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_COSTCENTER_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/cost-center-master-name`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_COSTCENTER_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getAllMasterCostCenterIdAndName function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_COSTCENTER_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getAllMasterCostCenterIdAndName function:", error);
            dispatch({
                type: "FIND_MASTER_COSTCENTER_NAME_FAILURE",
                payload: error,
            });
        }
    };
};

// ------------- committed -bank -master-----------------------

export const getMasterCommittedBank = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_COMMITTEDBANK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/committed-bank-master`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_COMMITTEDBANK_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getMasterCommittedBank function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_COMMITTEDBANK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterCommittedBank function:", error);
            dispatch({
                type: "FIND_MASTER_COMMITTEDBANK_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterCommittedBankIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_COMMITTEDBANK_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/committed-bank-master-name`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_COMMITTEDBANK_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getAllMasterCommittedBankIdAndName function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_COMMITTEDBANK_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getAllMasterCommittedBankIdAndName function:", error);
            dispatch({
                type: "FIND_MASTER_COMMITTEDBANK_NAME_FAILURE",
                payload: error,
            });
        }
    };
};

// -------------rcm category--master-----------------------

export const getMasterRcmCategory = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_RCM_CATEGORY_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/rcm-category-master`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_RCM_CATEGORY_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in rcm category function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_RCM_CATEGORY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterRcmCategory  function:", error);
            dispatch({
                type: "FIND_MASTER_RCM_CATEGORY_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterRcmCategoryIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_RCM_CATEGORY_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/rcm-category-master-name`;



        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_RCM_CATEGORY_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in RCM CATEGORY function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_RCM_CATEGORY_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterRcmCategory function:", error);
            dispatch({
                type: "FIND_MASTER_RCM_CATEGORY_NAME_FAILURE",
                payload: error,
            });
        }
    };
};


// -------------currency--master-----------------------

export const getMasterCurrency = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_CURRENCY_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/currency-master`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_CURRENCY_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in currency master function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_CURRENCY_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterCurrency function:", error);
            dispatch({
                type: "FIND_MASTER_CURRENCY_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllMasterCurrencyIdAndName = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_MASTER_CURRENCY_NAME_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/currency-master-name`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_MASTER_CURRENCY_NAME_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in MasterCurrencyIdAndName function (redux):", err);
                dispatch({
                    type: "FIND_MASTER_CURRENCY_NAME_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in MasterCurrencyIdAndName function:", error);
            dispatch({
                type: "FIND_MASTER_CURRENCY_NAME_FAILURE",
                payload: error,
            });
        }
    };
};



// ------------company info vis gst--------------------

export const getCompanyInfoViaGST = (token, user_id,) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_COMPANY_INFO_VIA_GST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/rcm-category-master-name`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_COMPANY_INFO_VIA_GST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in COMPANY_INFO_VIA_GST function (redux):", err);
                dispatch({
                    type: "FIND_COMPANY_INFO_VIA_GST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in COMPANY_INFO_VIA_GST function:", error);
            dispatch({
                type: "FIND_COMPANY_INFO_VIA_GST_FAILURE",
                payload: error,
            });
        }
    };
};


// ---------------ReceiptVoucher------------------demo testing



export const searchReceiptVoucher = (
    token,
    user_id,
    {
        page,
        search_text,
        from_date,
        to_date,
        voucher_type,
        branch_id,
        account_name_id,
        status,
        amount_from,
        amount_to,
    }
) => {
    return async function (dispatch) {
        alert(1)
        dispatch({
            type: "FIND_RECEIPT_VOUCHER_REQUEST",
        });

        const config = {
            headers: {
                "auth-token": token,
                user_id: user_id,
                "Content-Type": "application/json",
            },
        };

        let apiUrl = `${adminMainUrl}/api/account/receipt-voucher`;

        // Build query params dynamically
        const queryParams = [];

        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (from_date) queryParams.push(`from_date=${from_date}`);
        if (to_date) queryParams.push(`to_date=${to_date}`);
        if (voucher_type) queryParams.push(`voucher_type=${voucher_type}`);
        if (branch_id) queryParams.push(`branch_id=${branch_id}`);
        if (account_name_id) queryParams.push(`account_name_id=${account_name_id}`);
        if (status) queryParams.push(`status=${status}`);
        if (amount_from) queryParams.push(`amount_from=${amount_from}`);
        if (amount_to) queryParams.push(`amount_to=${amount_to}`);

        if (queryParams.length > 0) {
            apiUrl += `?${queryParams.join("&")}`;
        }


        try {
            const res = await axios.get(apiUrl, config);


            dispatch({
                type: "FIND_RECEIPT_VOUCHER_SUCCESS",
                payload: res?.data.data,
            });
        } catch (error) {
            console.log("ERROR in RECEIPT_VOUCHER function (redux):", error);
            dispatch({
                type: "FIND_RECEIPT_VOUCHER_FAILURE",
                payload: error,
            });
        }
    };
};


// ---------------Period Lock------------------

export const getAllPeriodLock = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_ALL_PERIOD_LOCK_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/period-lock`;

        //add page or search_Text in params
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search_text=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_ALL_PERIOD_LOCK_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in currency master function (redux):", err);
                dispatch({
                    type: "FIND_ALL_PERIOD_LOCK_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getMasterCurrency function:", error);
            dispatch({
                type: "FIND_ALL_PERIOD_LOCK_FAILURE",
                payload: error,
            });
        }
    };
};